import actions from 'react/api/actions';
import { fromJS } from 'immutable';

const initialState = fromJS({
  isOpen: false,
  countdown: 0,
  minutes: 0,
  seconds: 0
});

export default (state = initialState, action) => {

  if (actions.logoffAlertModal.actions.openModal === action.type){
    return state.mergeIn(['isOpen'], true);
  }

  if (actions.logoffAlertModal.actions.closeModal === action.type){
    return state.mergeIn(['isOpen'], false);
  }

  if (actions.logoffAlertModal.actions.setTimeToCountdown === action.type){
    const { payload: { time, actualMinutes, actualSeconds } } = action;
    return state.merge({
      'minutes': actualMinutes,
      'seconds': actualSeconds,
      'countdown': time
    });
  }

  if (actions.logoffAlertModal.actions.setTime === action.type){
    const { payload: { time, actualMinutes, actualSeconds } } = action;
    return state.merge({
      'minutes': actualMinutes,
      'seconds': actualSeconds,
      'countdown': time
    });
  }

  return state;
};
